import { render, staticRenderFns } from "./stripe_checkout.vue?vue&type=template&id=53f8646c"
import script from "./stripe_checkout.vue?vue&type=script&lang=js"
export * from "./stripe_checkout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports